import React from "react";
import { NullaryFn } from "@tvg/ts-types/Functional";
import { Button, DialogMessage, Modal } from "@tvg/design-system";

interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  description?: string;
  afterCloseCallback: NullaryFn<void>;
  onCancel: NullaryFn<void>;
  onConfirm: NullaryFn<void>;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title = "",
  description = "",
  onCancel,
  onConfirm,
  afterCloseCallback
}) => (
  <Modal
    title={
      <DialogMessage
        variant="info"
        title={title}
        description={description}
        mt="60px"
      />
    }
    onAfterClose={afterCloseCallback}
    onClose={onCancel}
    onOverlayClick={onCancel}
    isOpen={isOpen}
    type="lightbox"
    hasBorderBottom={false}
    p="space-4"
  >
    <>
      <Button
        qaLabel="cm-confirm"
        variant="primary"
        onPress={onConfirm}
        width="100%"
        mb="space-4"
      >
        Proceed
      </Button>
      <Button
        qaLabel="cm-cancel"
        variant="secondary"
        onPress={onCancel}
        width="100%"
      >
        Cancel
      </Button>
    </>
  </Modal>
);

export default ConfirmModal;
